import { driverApi } from "./driver.api";

export const {
  useListDriversInfiniteQuery,
  useLazySearchDriversQuery,
  useGetDriversQuery,
  useGetDriverQuery,
  useGetDriversGroupQuery,
  useLazyGetDriversGroupQuery,
  useDeleteDriverMutation,
  useEditDriverMutation,
  useUnbindDriverShippingCompanyMutation,
  useListDriversGroupInfiniteQuery
} = driverApi;
